import { useState } from 'react';
import { toast } from 'sonner';
import { convertChartToImage } from '@/utils/dataFormatter';
import * as ww from '@wecom/jssdk';
import { initWecom } from '@/utils/wecom';
import { WECOM_CORP_ID } from '@/config/env';
import { confirm } from '@/components/confirm';

export const useSend = () => {
  const [sending, setSending] = useState(false);
  let currentImageId = '';

  const sendData = async () => {
    const ok = await confirm({
      title: '发送',
      description: `是否发送"战略资产配置方案"卡片给客户？`
    });
    if (!ok) return;
    const chartElement = document.querySelector('[data-chart="assetAllocation"]') as HTMLElement;
    setSending(true);
    try {
      await initWecom({
        corpId: WECOM_CORP_ID
      });
    } catch (error) {
      toast.error('初始化企微失败，发送失败');
      setSending(false);
      return;
    }
    if (chartElement) {
      try {
        const imageId = await convertChartToImage(chartElement);
        currentImageId = imageId;
      } catch (error) {
        console.error('Failed to convert asset allocation chart:', error);
        currentImageId = '';
      }
    }

    try {
      await ww.sendChatMessage({
        msgtype: 'text',
        text: {
          content: `您好，这是根据您的投资需求做的分析，如果您需要调整需求或想深入讨论，请随时告诉我们，我很乐意为您细化配置。\n`
        }
      });
      // 再发送图片，确保标题发送完成后才发图片
      console.log(currentImageId);

      await ww.sendChatMessage({
        msgtype: 'image',
        image: {
          mediaid: currentImageId
        }
      });
    } catch (error) {
      console.error('发送失败:', error);
      toast.error(`发送失败: ${error}`);
    } finally {
      setSending(false);
    }
  };

  return {
    sending,
    sendData
  };
};
